import { render, staticRenderFns } from "./FormBird.vue?vue&type=template&id=573f1464&"
import script from "./FormBird.vue?vue&type=script&lang=js&"
export * from "./FormBird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports